/** Spanish for the planning area (docs/conventions/i18n.md). Keys are the English copy, verbatim. */
export const esPlanning: Readonly<Record<string, string>> = {
  'Remind days before': 'Avisar días antes',
  'Empty: 90 days, time to renew it': 'Vacío: 90 días, para que dé tiempo a renovarlo',
  'Can start on': 'Se puede empezar el',
  'Until then it waits, without alerts': 'Hasta entonces espera, sin avisos',
  'Empty or 0: only on the day it is due': 'Vacío o 0: solo el día que vence',
  // Shared within the area
  Add: 'Añadir',
  Title: 'Título',
  Type: 'Tipo',
  Notes: 'Notas',
  // Documents
  Documents: 'Documentos',
  'Copies of the important paperwork, available offline on all your devices.':
    'Copias de la documentación importante, disponibles sin conexión en todos vuestros dispositivos.',
  'Search documents': 'Buscar documentos',
  'No documents yet': 'Aún no hay documentos',
  'ID cards, passports, deeds, insurance policies, medical reports, prescriptions… Take a photo or upload the PDF.':
    'DNI, pasaportes, escrituras, pólizas, informes médicos, recetas… Haz una foto o sube el PDF.',
  'Add document': 'Añadir documento',
  'New document': 'Nuevo documento',
  'Document saved': 'Documento guardado',
  'Document added': 'Documento añadido',
  "e.g. Romi's passport": 'p. ej. Pasaporte de Romi',
  Holder: 'Titular',
  Both: 'Ambos',
  'Issued on': 'Expedido el',
  'Expires on': 'Caduca el',
  'Where the original is': 'Dónde está el original',
  'Blue folder, safe…': 'Carpeta azul, caja fuerte…',
  // Notes
  'Plans, emergency contacts, meeting points, procedures…':
    'Planes, contactos de emergencia, puntos de encuentro, procedimientos…',
  'Search notes': 'Buscar en las notas',
  'No notes': 'Sin notas',
  'Write down the emergency plan, important phone numbers or anything you want at hand offline.':
    'Escribe el plan de emergencia, teléfonos importantes o cualquier cosa que queráis tener a mano sin conexión.',
  'Write a note': 'Escribir una nota',
  'New note': 'Nueva nota',
  'Note saved': 'Nota guardada',
  Text: 'Texto',
  Tags: 'Etiquetas',
  'Pin to the top': 'Fijar arriba',
  Pinned: 'Fijada',
  'No content': 'Sin contenido',
  // Tasks
  Tasks: 'Tareas',
  'Pending actions, advice to follow and periodic checks of the kit.':
    'Acciones pendientes, recomendaciones a seguir y revisiones periódicas del kit.',
  'Open tasks': 'Pendientes',
  Recommendations: 'Recomendaciones',
  Closed: 'Cerradas',
  'You have not closed any yet.': 'Aún no habéis cerrado ninguna.',
  'No recommendations': 'Sin recomendaciones',
  'Nothing to do': 'Nada pendiente',
  'Keep advice you want to follow: rotate the water every 6 months, learn first aid…':
    'Guarda consejos que quieras seguir: rotar el agua cada 6 meses, aprender primeros auxilios…',
  'Write down actions with a date, or checks that repeat every so often.':
    'Apunta acciones con fecha, o revisiones que se repiten cada cierto tiempo.',
  'New task': 'Nueva tarea',
  'Task saved': 'Tarea guardada',
  'Task added': 'Tarea añadida',
  'Task done': 'Tarea hecha',
  'Done. Next check: {date}': 'Hecha. Próxima revisión: {date}',
  'Mark as done': 'Hecha',
  'e.g. Check the first aid kit': 'p. ej. Revisar el botiquín',
  Priority: 'Prioridad',
  'Due on': 'Para el',
  'Repeat every': 'Repetir cada',
  Never: 'Nunca',
  Period: 'Periodo',
  days: 'días',
  weeks: 'semanas',
  months: 'meses',
  years: 'años',
  'Marking it done schedules the next one': 'Al marcarla hecha se programa la siguiente',
  Status: 'Estado',
  'Steps, links, why…': 'Pasos, enlaces, por qué…',
  'Last done: {date}': 'Última vez hecha: {date}',
  'every {count} month': 'cada {count} mes',
  'every {count} months': 'cada {count} meses',
  'every {count} day': 'cada {count} día',
  'every {count} days': 'cada {count} días',
  'every {count} week': 'cada {count} semana',
  'every {count} weeks': 'cada {count} semanas',
  'every {count} year': 'cada {count} año',
  'every {count} years': 'cada {count} años',
  'in progress': 'en curso',
  Checklist: 'Lista de pasos',
  'Add step': 'Añadir paso',
  'Step {number}': 'Paso {number}',
  'Remove step {number}': 'Quitar el paso {number}',
  Reopen: 'Reabrir',
};
